import { Box, styled } from "@mui/material";

import React, { useCallback, useContext, useEffect, useState } from "react";
import { RetailContext } from "../../../contexts/retail/retailMain.context";
import { isMobile } from "../../../utils/helper";
import { useRouter } from "../../../utils/hooks/useRouter";
import BackToHomeKiotOnline from "../../KiotOnline/BackToMenu";
import { IconLoadProgress } from "../../Static/Icons/Icon";
import LinearProgressEx from "../../Static/Progress/LinearProgressEx";
import { SlideProgressActive } from "../../Static/SlideProgressActive/SlideProgressActive";
import BackToMenu from "../Mobile/BackToMenu";
import { Redirect } from "../../../utils/Redirect";
// import {
//   updateRetailWebsiteStatus,
//   updateSyncStatus,
// } from "../../../services/api/retail/websiteStatusApi";

const DomUrlWebsite = styled("div")({
  paddingTop: "100px",
  maxWidth: "600px",
  margin: "0 auto",
  "> div:nth-of-type(2)": {},
});

const DomLoadProgress = styled("div")({
  marginTop: "48px",
  padding: "16px 20px",
  display: "flex",
  gap: "16px",
  borderRadius: "12px",
  fontSize: "14px",
  alignItems: "center",
  boxShadow:
    "0px 4px 24px rgba(0, 0, 0, 0.05), 0px 1px 5px rgba(0, 0, 0, 0.05)",
});

const DomUrlMobile = styled("div")({
  padding: "100px 12px 0 12px",
  maxWidth: "600px",
  margin: "0 auto",
  "> div:nth-of-type(2)": {},
});

const DomLoadMobile = styled("div")({
  paddingTop: "40px",
  margin: "0 auto",
  width: "300px",
  display: "flex",
  gap: "16px",
  textAlign: "center",
  borderRadius: "12px",
  fontSize: "14px",
  alignItems: "center",
});

export default function ActiveProgressWeb() {
  const { progress, setProgress, status } = useContext(RetailContext);
  const [link, setLink] = useState("");
  const [fakeProgress, setFakeProgress] = useState(0);
  const maxFakePercent = 100;
  const newOnboard = true;
  const arrFakePercent: { [key: number]: number } = {
    0: 10,
    10: 20,
    20: 30,
    30: 48,
    48: 56,
    56: 64,
    64: 70,
    70: 75,
    75: 80,
    80: 85,
    85: 100,
  };
  const router = useRouter();

  useEffect(() => {
    const link = `${process.env.REACT_APP_ADMIN_URL}/retail/sso?code=${router?.query?.code}&website_url=preview`;
    setLink(link);
    console.log("---link---", link);
  }, [router.query]);

  useEffect(() => {
    if (fakeProgress >= maxFakePercent) return;
    const timer = setInterval(() => {
      const nextProgress = arrFakePercent[fakeProgress];
      setProgress &&
        setProgress((prevProgress: number) => {
          return nextProgress > prevProgress ? nextProgress : prevProgress;
        });

      setFakeProgress(nextProgress);
      if (nextProgress >= maxFakePercent) {
        clearInterval(timer);

        //handle set status
        const platform = router.query.platform;
        if (!platform || typeof platform !== "string") {
          return () => {
            Redirect({ to: "/session-expired" });
          };
        }

        if (status === 1) {
          // Promise.all([
          //   updateRetailWebsiteStatus({ step_code: 1, platform }),
          //   updateSyncStatus({ newStatus: false, platform }),
          // ]).then(() => {
          //   //case1: change status
          //   // changeStatus && changeStatus(3);

          //   //case2: handle open preview website
          //   console.log("---link---", link);
          //   window && (window as any).mykiotPreviewWebsite(link);
          // });
          setTimeout(() => {
            window && (window as any).mykiotPreviewWebsite(link);
          }, 600)
        }
      }
    }, 200);
    return () => {
      clearInterval(timer);
    };
  }, [fakeProgress, status]);

  const BackToHome = useCallback(() => {
    switch (router.query.platform) {
      case "kiotonline":
        return <BackToHomeKiotOnline />;
      case "retail":
        return isMobile() ? <BackToMenu /> : <></>;
      default:
        return <></>;
    }
  }, [router.query.platform]);

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      {newOnboard ? (
        <>
          {isMobile() ? (
            <DomUrlMobile>
              <SlideProgressActive />
              <DomLoadMobile>
                <div>
                  <div style={{ marginBottom: "5px", marginTop: "7px" }}>
                    <b>{progress}%</b> Cửa hàng của bạn đang khởi tạo, vui lòng
                    chờ trong giây lát...
                  </div>
                  <LinearProgressEx progress={progress} />
                </div>
              </DomLoadMobile>
            </DomUrlMobile>
          ) : (
            <DomUrlWebsite>
              <SlideProgressActive />
              <DomLoadProgress>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <IconLoadProgress />
                </div>
                <div>
                  <div style={{ marginBottom: "5px", marginTop: "7px" }}>
                    <b>{progress}%</b> Cửa hàng của bạn đang khởi tạo, vui lòng
                    chờ trong giây lát...
                  </div>
                  <LinearProgressEx progress={progress} />
                </div>
              </DomLoadProgress>
            </DomUrlWebsite>
          )}

          <BackToHome />
        </>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",

              "@media (max-width: 600px)": {
                mt: "24px",
              },
            }}
            mt={8}
          >
            <img
              src={
                process.env.REACT_APP_ADMIN_URL +
                "/img/retail/sync_progress.gif"
              }
              alt="Picture of the author"
              width={461}
              height={461}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: 320,
              }}
            >
              <LinearProgressEx progress={progress} />
            </Box>
          </Box>

          <BackToHome />
        </>
      )}
    </Box>
  );
}
